import { PeopleEmailStatus } from '@aibees/elephant/feature/search-table-people/types';
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { STATUS_COLOR } from './utils';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  gap: 1,
  padding: 0,
};

export const emailTypeIcon: SxStyleFunc<{
  status?: PeopleEmailStatus;
  needsEnrichEmail: boolean;
}> = ({ status, needsEnrichEmail }) => ({
  color: (p) =>
    status === PeopleEmailStatus.ERROR || needsEnrichEmail
      ? p.palette.primary[100]
      : p.palette.primary[500],
});

export const verticalDivider: SxStyle = {
  height: (p) => p.spacing(1.5),
  borderColor: (p) => p.palette.grey[300],
};

export const kindBox: SxStyle = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  span: {
    lineHeight: 1.3,
    color: (p) => p.palette.grey[600],
    fontSize: (p) => p.typography.body5,
    fontWeight: 500,
  },
  border: (p) => `0.5px solid ${p.palette.grey[300]}`,
  paddingLeft: 1.25,
  paddingRight: 1,
  borderRadius: 3,
};

export const kindBadge: SxStyleFunc<{
  status?: PeopleEmailStatus;
  unlocked: boolean;
  hasUpdate: boolean;
  reverify: boolean;
  needsEnrichEmail: boolean;
}> = ({ status, unlocked, hasUpdate, reverify, needsEnrichEmail }) => {
  const finalStatus = !unlocked
    ? PeopleEmailStatus.UNKNOWN
    : needsEnrichEmail
    ? PeopleEmailStatus.OUTDATED
    : hasUpdate
    ? PeopleEmailStatus.UPDATE
    : reverify
    ? PeopleEmailStatus.CATCH_ALL
    : status ?? PeopleEmailStatus.LOCKED;

  return {
    '.MuiBadge-dot': {
      backgroundColor: `${STATUS_COLOR[finalStatus]} !important`,
      height: (p) => p.spacing(0.75),
      minWidth: (p) => p.spacing(0.75),
    },
  };
};

export const info: SxStyle = {
  // border: (p) => `0.5px solid ${p.palette.grey[300]}`,
  width: 'fill-available',
  padding: 0,
  ':hover': {
    borderColor: (p) => p.palette.grey[500],
  },
};

export const copyIcon: SxStyle = {
  button: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
  },
};

export const emailStatusInfoBadge: SxStyle = {
  '.MuiBadge-badge': {
    width: (p) => p.spacing(1.25),
    height: (p) => p.spacing(1.25),
    minWidth: (p) => p.spacing(1.25),
    top: (p) => `-${p.spacing(1.4)}`,
    right: (p) => `-${p.spacing(5)}`,
    padding: 0,
    backgroundColor: (p) => p.palette.common.white,
  },
};
